
import * as fromSystemUserRoleReducer from './system-user-role.reducer';
import {createSelector} from '@ngrx/store';

import {AppState} from "../../../../index";

export const currentState = (state: AppState) => (state[fromSystemUserRoleReducer.systemUserRolesFeatureKey]);


export const selectAllSystemUserRoles = createSelector(currentState, fromSystemUserRoleReducer.selectAll);

export const selectSystemUserRoleByUuid = (uuid: string) => createSelector(
  selectAllSystemUserRoles,
  (systemUserRoles) => systemUserRoles.find(c => c.uniqueId === uuid)
);

export const selectSystemUserRolesLoadingState = createSelector(currentState, fromSystemUserRoleReducer.getLoading);

